import React from 'react';
import './AccountOrders.scss';
import AccountOrder from './AccountOrder/AccountOrder';

/**
 * Renders orders section associated with an account
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const AccountOrders = ({ customer, activeSection }) => {
  const ORDERS_SECTION = 'Order History';

  /**
   * Render the orders
   * @param data
   * @returns {*}
   */
  const renderOrders = (data) => {
    if (data.length !== 0) {
      return data.map((order, i) => {
        return (
          <AccountOrder
            key={`order-${i}`}
            name={order.name}
            url={order.url}
            createdAt={order.createdAt}
            total={order.total}
          />
        );
      });
    } else {
      return <small className="c-account-orders__empty">You have no orders.</small>;
    }
  };

  return (
    <div className={`c-account-orders ${activeSection === ORDERS_SECTION ? 'is-active' : ''}`}>
      <h3 className="c-account-orders__heading h3-roobert">Order History</h3>
      {customer.orders.length !== 0 && (
        <table className="c-account-orders__list">
          <thead>
            <tr className="c-account-orders__row c-account-orders__row--header">
              <th className="c-account-orders__cell c-account-orders__cell--header eyebrow-2">
                ORDER
              </th>
              <th className="c-account-orders__cell c-account-orders__cell--header eyebrow-2">
                DATE
              </th>
              <th className="c-account-orders__cell c-account-orders__cell--header eyebrow-2">
                TOTAL
              </th>
            </tr>
          </thead>
          <tbody>{renderOrders(customer.orders)}</tbody>
        </table>
      )}
    </div>
  );
};

export default AccountOrders;
